import { render, staticRenderFns } from "./CotValutazioneUvmSchedaPazienteEditComponent.vue?vue&type=template&id=2d04823d"
import script from "./CotValutazioneUvmSchedaPazienteEditComponent.vue?vue&type=script&lang=js"
export * from "./CotValutazioneUvmSchedaPazienteEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports